import { render } from "./NotificationSurveyItemsListView.vue?vue&type=template&id=7f4c44ac&scoped=true&ts=true"
import script from "./NotificationSurveyItemsListView.vue?vue&type=script&lang=ts"
export * from "./NotificationSurveyItemsListView.vue?vue&type=script&lang=ts"

import "./NotificationSurveyItemsListView.vue?vue&type=style&index=0&id=7f4c44ac&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f4c44ac"]])

export default __exports__